<template>
    <div>
        <config-main-title>
            Laudo Distribuição
        </config-main-title>
        
        <div class="alert alert-info d-flex justify-content-between" v-if="nome_medico">
            <div>
                {{ nome_medico }}
            </div>
            <div>
                <a href="#" @click.prevent="$emit('fechar')">
                    <i class="fa-solid fa-chevron-left"></i>
                </a>
            </div>
        </div>

        <div>
            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="false">
                            <importacao service="laudo_distribuicoes" :parms="{ id_medico_comp: id_mdedico }" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Profissional
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fas fa-search" msg="Nenhuma profissional identificado." 
                :action="!search ? 'Incluir Profissional' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3 ml-0">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span class="d-flex">
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <span v-else>
                                <span class="badge badge-secondary mr-3" v-if="dado.distribuido_dia">
                                    Hoje: 
                                    <span v-if="dado.in_limite_diario">
                                        {{ dado.distribuido_dia }}/{{ dado.in_limite_diario }}
                                    </span>
                                    <span v-else>
                                        {{ dado.distribuido_dia }}
                                    </span>
                                </span>

                                <span class="badge badge-secondary mr-3">
                                    {{ dado.distribuido }}/{{ dado.in_peso }}
                                </span>

                                <span class="badge badge-secondary mr-3">
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                    {{ dado.in_regra_ordem }}
                                </span>
                            </span>
                        </span>
                    </div>
                </li>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="laudoDistribuicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Profissional
                            {{ item.id_laudo_distribuicao ? '#' + item.id_laudo_distribuicao : '(Novo)' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Profissional"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="medicos.index"
                                    required
                                    :validate="validate"
                                    v-model="item.medico">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.medico">
                                            <span class="input-group-text">
                                                #{{ item.medico.id_pessoa }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Peso"
                                    placeholder="Informar..."
                                    required
                                    :validate="validate"
                                    v-model="item.in_peso" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Limite Diário (Opcional)"
                                    placeholder="Sem limite..."
                                    :validate="validate"
                                    v-model="item.in_limite_diario" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Ordem"
                                    required
                                    :validate="validate"
                                    v-model="item.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="laudoDistribuicao" :id="item.id_laudo_distribuicao" v-if="item && item.id_laudo_distribuicao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from '../../util/AzBreakTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            item: null,  
            validate: false, 
            viewMode: "A",
            produto: null, 
            lista_unidade_operacao_planos: [],
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        Importacao,
        ConfigMainTitle
    }, 

    props: ['id_medico', 'nome_medico'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo )
                .filter (item => { 
                    return !this.search || reg.test(JSON.stringify(item));
                }) : null ; 
        }
    },

    methods: { 
        incluir () { 
            this.validate = false;
            
            this.item = { 
                id_medico_comp: this.id_medico,
                id_medico: null, 
                medico: null, 
                in_peso: 1, 
                in_limite_diario: null, 
                in_regra_ordem: 100, 
                fl_ativo: true, 
                st_obs: "", 
            }

            $('#laudoDistribuicaoModal').modal('show');

        },

        editar (item) { 

            this.validate = false;
            this.item = { ...item };

            $('#laudoDistribuicaoModal').modal('show');

        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'laudo_distribuicoes',
                dados: item,
            });

        },

        atualizar () { 

            this.item.id_medico = this.item.medico ? this.item.medico.id_pessoa : null;

            this.$util.atualizar (this, { 
                service: 'laudo_distribuicoes',
                dados: this.item,
                reload: true, 
                modal: 'laudoDistribuicaoModal',
            });

        },

        load () { 
            this.$util.load(this, { 
                service: 'laudo_distribuicoes',
                func: 'index',
                parms: { 
                    where: { 
                        id_medico_comp: this.id_medico,
                    },
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    created () { 
        this.$store.commit('loading', true);
    },

    mounted () { 
        this.load (); 
        $('.tooltip').tooltip('hide');
    }
}
</script>